export default __webpack_public_path__ + "static/media/bannerImage-3.34ef33ea.jpg";